import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ children }) => {
  const authSession = localStorage.getItem("authSession");

  if (!authSession) {
    return <Navigate to="/login" replace />;
  }

  try {
    const session = JSON.parse(authSession);
    const now = Date.now();

    // Check if session has expired (24 hours)
    if (now > session.expiresAt) {
      localStorage.removeItem("authSession");
      return <Navigate to="/login" replace />;
    }

    return children;
  } catch (error) {
    localStorage.removeItem("authSession");
    return <Navigate to="/login" replace />;
  }
};

export const checkAuthStatus = () => {
  const authSession = localStorage.getItem("authSession");
  
  if (!authSession) {
    return false;
  }

  try {
    const session = JSON.parse(authSession);
    const now = Date.now();
    
    if (now > session.expiresAt) {
      localStorage.removeItem("authSession");
      return false;
    }
    
    return true;
  } catch (error) {
    localStorage.removeItem("authSession");
    return false;
  }
};

export const logout = () => {
  localStorage.removeItem("authSession");
  sessionStorage.removeItem("pendingAuth");
};
